<template>
  <div class="card-content is-marginless">
    <div class="columns is-multiline">
      <div class="column is-marginless is-paddingless is-12 columns mgb-0">
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.texte')"
          class="column is-9">
          <div v-if="!detail">
            <qd-text-editor
              v-model="relanceInformations.texte"
              :height="500"
              @ready="ckeditorIsReady">
            </qd-text-editor>
          </div>
          <p v-else v-html="relanceInformations.texte"></p>
        </b-field>
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.baliseAAjouter')"
          class="column is-3">
          <div class="columns is-multiline">
            <div
              v-for="balise in balises" :key="balise"
              @click="addBalise(balise)"
              role="button"
              class="column is-6">
              <p class="has-text-weight-bold is-cursor-pointer">
                {{ `\{${balise}\}` }}
              </p>
              <p class="has-text-default">
                {{ $t(`addEditRegleFacturation.balise.${balise}`) }}
              </p>
            </div>
          </div>
        </b-field>
      </div>
      <b-field
        :label="$t('addEditRegleFacturation.informationRegleFacturation.piedPage')"
        class="column is-9">
        <qd-text-editor
          v-if="!detail"
          v-model="relanceInformations.piedPage"
          :height="150">
        </qd-text-editor>
        <p v-else v-html="relanceInformations.piedPage"></p>
      </b-field>
      <div class="column is-12 columns is-marginless is-paddingless is-multiline">
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.signataire')"
          class="column is-3">
          <b-input v-if="!detail" v-model="relanceInformations.signataire"></b-input>
          <p v-else>{{ relanceInformations.signataire }}</p>
        </b-field>
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.fonctionSignataire')"
          class="column is-3">
          <b-input v-if="!detail" v-model="relanceInformations.fonctionSignataire"></b-input>
          <p v-else>{{ relanceInformations.fonctionSignataire }}</p>
        </b-field>
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.sizeWidth')"
          class="column is-3">
          <b-input
            v-if="!detail"
            v-model.number="relanceInformations.logoTailleX"
            type="number">
          </b-input>
          <p v-else>{{ relanceInformations.logoTailleX }}</p>
        </b-field>
        <b-field
          :label="$t('addEditRegleFacturation.informationRegleFacturation.sizeHeight')"
          class="column is-3">
          <b-input
            v-if="!detail"
            v-model.number="relanceInformations.logoTailleY"
            type="number">
          </b-input>
          <p v-else>{{ relanceInformations.logoTailleY }}</p>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'setRelanceInformations',
  data() {
    return {
      balises: [
        'tableauEcheance',
        'dateRelance',
        'blocDestinataire',
        'logo',
        'blocCommercial',
        'signataire',
        'fonctionSignataire',
        'lieu',
        'compteClient',
      ],
    };
  },
  props: {
    relanceInformations: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    addBalise(balise) {
      const currentPosition = this.editor.getSelection().getRanges()[0];
      if (currentPosition) {
        this.editor.insertHtml(`{${balise}}`, currentPosition);
      } else {
        this.editor.insertHtml(`{${balise}}`, 0);
      }
    },
    ckeditorIsReady(event) {
      this.editor = event;
    },
  },
};
</script>

<style scoped>

</style>
